'use es6';

import Widget from 'DesignData/models/widgets/Widget';
/**
 * Represents `section_delimiter` widgets.
 */

export default class SectionDelimiter extends Widget {
  /**
   * @constructor
   */
  constructor() {
    return super({});
  }
  /**
   * @override
   * @return {Object}
   */


  generateNewLayoutWidgetObject() {
    const superWidgetObject = super.generateNewLayoutWidgetObject();
    return Object.assign({}, superWidgetObject, {
      type: 'section_delimiter',
      params: {},
      x: 0,
      w: 12
    });
  }

}